module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"daily":"Daily","monthly":"Monthly","target":"Target Achievement Rate","achieved":"Achieved","remaining":"Remaining","target_tooltip":"This section visualizes your progress of achieving your set daily and monthly goals  ","unit":"¥"}}')
  delete Component.options._Ctor
}
